import NameSyncStatus from "../../../components/devices/NameSyncStatus";
import React from "react";
import TextInput from "../../../components/common/inputs/textInput";
import SelectInput from "../../../components/common/inputs/selectInput";
import ToggleInput from "../../../components/common/inputs/toggleInput";

import Loading from "../../../components/common/loading";
import ModalManager from "../../../components/common/modal/ModalManager";

import RowList from "../../../components/common/rowList";
import OutletTrendPanel from "../../../components/devices/OutletTrendPanel";
import { apiErrorMessageFromError } from "../../../utils/apiErrorMessage";



export default class DevicePageOutletPage extends React.Component {
  initialState = {
    outletName: "",
    pwrOnState: "",
    customRebootTimeEnabled: false,
    customRebootTime: 0,
    state: "ON",
    saving: false,
    hasChanges: false,
    hasNameChanges: false,
    savingName: false,
    nameError: "",
    settingsError: "",
    switching: false,
    switchingAction: "",
  };

  state = {
    ...this.initialState,
  };
  async componentDidMount() {
    if (this.props.outletId) {
      this.prepopulateOutletInfo(this.props);
    }
  }

  prepopulateOutletInfo = (props = this.props) => {
    const { outlets = [], outletId } = props;

    if (!outletId) {
      this.setState({ ...this.initialState });
      return;
    }

    const outlet = outlets.find((entry) => entry.outlet_id == outletId);

    if (outlet) {
      this.setState({
        outletName: outlet.outletName || "",
        pwrOnState: outlet.pwrOnState || "",
        customRebootTimeEnabled: Boolean(outlet.customRebootTimeEnabled),
        customRebootTime:
          outlet.customRebootTime !== undefined && outlet.customRebootTime !== null
            ? outlet.customRebootTime
            : 0,
        state: outlet.state || "ON",
        saving: false,
        savingName: false,
        hasChanges: false,
        hasNameChanges: false,
        nameError: "",
        settingsError: "",
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.outletId !== this.props.outletId ||
      (prevProps.outlets !== this.props.outlets &&
        !this.state.hasChanges && !this.state.hasNameChanges &&
        !this.state.saving && !this.state.savingName)
    ) {
      this.prepopulateOutletInfo(this.props);
    }
  }
  onSaveName = () => {
    if (!this.canEditOutlets() || this.state.savingName) return;
    const outletName = this.state.outletName.trim();
    if (!outletName) {
      this.setState({ nameError: "Outlet name is required." });
      return;
    }
    this.setState({ savingName: true, nameError: "" });
    this.props.updateOutlet(this.props.outletId, { outletName }, (err) => {
      this.setState(err ? {
        savingName: false,
        nameError: apiErrorMessageFromError(err, "Unable to save outlet name."),
      } : {
        outletName,
        savingName: false,
        hasNameChanges: false,
      });
    });
  };

  canEditOutletSettings = () => {
    const outlet = this.props.outlets?.find((entry) => entry.outlet_id == this.props.outletId);
    return this.canEditOutlets() && this.props.device?.connectionState === "Connected" &&
      outlet?.connectionState === "Connected";
  };

  onSave = () => {
    if (!this.canEditOutletSettings() || this.state.saving) {
      return;
    }
    this.setState({
      saving: true,
      settingsError: "",
    });
    this.props.updateOutlet(this.props.outletId, {
      pwrOnState: this.state.pwrOnState,
      customRebootTimeEnabled: this.state.customRebootTimeEnabled,
      customRebootTime: this.state.customRebootTime,
    }, (err, res) => {
      if (err) {
        console.log(err);
        this.setState({
          saving: false,
          settingsError: apiErrorMessageFromError(err, "Unable to save outlet settings."),
        });
      } else {
        this.setState({
          saving: false,
          hasChanges: false,
        });
      }
    });
  }
  onCancel = () => {
    const outlet = this.props.outlets?.find((entry) => entry.outlet_id == this.props.outletId);
    if (!outlet) return;
    this.setState({
      pwrOnState: outlet.pwrOnState || "",
      customRebootTimeEnabled: Boolean(outlet.customRebootTimeEnabled),
      customRebootTime: outlet.customRebootTime ?? 0,
      hasChanges: false,
      settingsError: "",
    });
  };

  switchOutletState = (nextState) => {
    const { outletId, outlets = [], updateOutlet } = this.props;

    if (
      !outletId ||
      !updateOutlet ||
      this.state.switching ||
      !this.canSwitchOutlets()
    ) {
      return;
    }

    const outlet = outlets.find((entry) => entry.outlet_id == outletId);
    if (this.props.device?.connectionState !== "Connected" || outlet?.connectionState !== "Connected") return;
    const outletNumber = outlet?.pduLabeledOutletNum || outletId;
    const actionLabel =
      nextState === "REBOOT"
        ? "power cycle"
        : nextState === "ON"
          ? "turn on"
          : "turn off";
    const confirmLabel =
      nextState === "REBOOT"
        ? "Power cycle"
        : nextState === "ON"
          ? "Turn on"
          : "Turn off";

    ModalManager.confirm(
      `Are you sure you want to ${actionLabel} Outlet ${outletNumber}?`,
      "Are you sure?",
      confirmLabel,
      (submitted, close) => {
        if (!submitted) {
          return;
        }

        if (typeof close === "function") {
          close();
        }

        this.setState({
          switching: true,
          switchingAction: nextState,
        });

        updateOutlet(outletId, { state: nextState }, (err) => {
          if (err) {
            console.log(err);
          }
          this.setState({
            switching: false,
            switchingAction: "",
          });
        });
      }
    );
  };

  canEditOutlets = () => {
    const permissions = this.props.effectivePermissions;
    const role = this.props.user?.role;
    return permissions
      ? Boolean(permissions.ready && permissions.canEditOutlets)
      : !role || role.editAllOutletsAllowed === true;
  };

  canSwitchOutlets = () => {
    const permissions = this.props.effectivePermissions;
    const role = this.props.user?.role;
    return permissions?.ready
      ? Boolean(permissions.canSwitchOutlets)
      : !role || role.switchAllOutletsAllowed === true;
  };

  render() {
    const {
      outlets = [],
      outletId,
      device,
      loading,
      loaded,
    } = this.props;

    const serial = device?.enclosureSerialNumber;

    const outletSelect = (
      <div className="cell ">
        <div
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <select
            value={outletId || ""}
            style={{
              margin: "0px",
            }}
            onChange={(e) => {
              const selectedOutletId = e.target.value;
              if (!serial) {
                return;
              }
              const basePath = `/devices/connected/${serial}/outlets`;
              if (selectedOutletId) {
                this.props.history.push(`${basePath}/${selectedOutletId}`);
              } else {
                this.props.history.push(basePath);
              }
            }}
            disabled={!serial}
          >
            <option value="">Select An Outlet</option>
            {(outlets || []).map((outlet) => (
              <option key={outlet.outlet_id} value={outlet.outlet_id}>
                Outlet {outlet.pduLabeledOutletNum}{" "}
                {outlet.outletName === `Outlet ${outlet.pduLabeledOutletNum}`
                  ? ""
                  : `- ${outlet.outletName}`}{" "}
                ({(outlet.currentRms || 0).toFixed(2)} A)
              </option>
            ))}
          </select>
        </div>
      </div>
    );

    const outlet = outlets.find((entry) => entry.outlet_id == outletId);

    if (!outlet) {
      return (
        <div className="grid-container">
          <div className="grid-x grid-padding-x grid-padding-y">
            {outletSelect}
            <div className="cell">
              {loading || !loaded ? (
                <Loading description="Loading outlet details..." />
              ) : (
                <div>No outlet data available for the selected outlet.</div>
              )}
            </div>
          </div>
        </div>
      );
    }

    const supportsOutletMeasurements = Boolean(
      device?.outletPwrMeasurementsSupported &&
      serial &&
      outlet?.outlet_id
    );
    const outletSubtitle = (() => {
      const base = `Outlet ${outlet.pduLabeledOutletNum || outlet.outlet_id}`;
      if (
        outlet.outletName &&
        outlet.outletName !== `Outlet ${outlet.pduLabeledOutletNum}`
      ) {
        return `${base} – ${outlet.outletName}`;
      }
      return base;
    })();
    const canSwitchOutlets = this.canSwitchOutlets();
    const canEditOutlets = this.canEditOutlets();
    const canEditSettings = this.canEditOutletSettings();
    const outletSwitchingAvailable =
      outlet.state !== undefined && outlet.state !== null;
    const outletConnected = outlet.connectionState === "Connected" && device?.connectionState === "Connected";
    const currentOutletState = outlet.state || "Unknown";
    const pendingPowerState =
      outlet.rebootStatus === "pendingOn"
        ? "Pending on"
        : outlet.rebootStatus === "pendingOff"
          ? "Pending off"
          : "";
    const switchUnavailableReason = !outletSwitchingAvailable
      ? "This outlet does not expose switch controls."
      : !outletConnected
        ? "Outlet switching is unavailable while the device or outlet is disconnected."
        : !canSwitchOutlets
          ? "Your role does not allow outlet switching."
          : "";
    const disablePowerActions = Boolean(
      this.state.switching || switchUnavailableReason
    );
    const powerActions = [
      {
        state: "ON",
        label: "Turn on",
        icon: "offline_bolt",
        className: "outlet-power-control__button--on",
        disabled: currentOutletState === "ON",
      },
      {
        state: "OFF",
        label: "Turn off",
        icon: "pause_circle",
        className: "outlet-power-control__button--off",
        disabled: currentOutletState === "OFF",
      },
      {
        state: "REBOOT",
        label: "Power cycle",
        icon: "replay",
        className: "outlet-power-control__button--cycle",
      },
    ];

    return (
      <div className="grid-container">
        <div className="grid-x grid-padding-x grid-padding-y">
          {outletSelect}
          {loading && loaded && (
            <div
              className="cell"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Loading size="16px" />
            </div>
          )}
          <div className="cell" style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
          }}>
            <h4  style={{ margin: "0px" }}>
              Outlet {outlet.pduLabeledOutletNum}{" "}
              {outlet.outletName ===
              `Outlet ${outlet.pduLabeledOutletNum}`
                ? ""
                : `- ${outlet.outletName}`}
              <NameSyncStatus resource={outlet} />
            </h4>

          </div>
          {canSwitchOutlets ? (
          <div className="cell">
            <section className="outlet-power-control">
              <div className="outlet-power-control__header">
                <div>
                  <div className="outlet-power-control__eyebrow">
                    Outlet power control
                  </div>
                  <h5 className="outlet-power-control__title">
                    Switch outlet {outlet.pduLabeledOutletNum || outlet.outlet_id}
                  </h5>
                  <p className="outlet-power-control__description">
                    {switchUnavailableReason ||
                      "Turn the outlet on or off, or power cycle it using the configured reboot time."}
                  </p>
                </div>
                <div
                  className={`outlet-power-control__state outlet-power-control__state--${String(
                    currentOutletState
                  ).toLowerCase()}`}
                >
                  <span>{currentOutletState}</span>
                  {pendingPowerState ? <small>{pendingPowerState}</small> : null}
                </div>
              </div>
              <div className="outlet-power-control__actions">
                {powerActions.map((action) => {
                  const actionDisabled =
                    disablePowerActions || Boolean(action.disabled);
                  const isActiveAction =
                    this.state.switchingAction === action.state;

                  return (
                    <button
                      key={action.state}
                      type="button"
                      className={`button outlet-power-control__button ${action.className}`}
                      onClick={() => this.switchOutletState(action.state)}
                      disabled={actionDisabled}
                    >
                      {isActiveAction ? (
                        <Loading size="16px" />
                      ) : (
                        <i className="material-icons" aria-hidden="true">
                          {action.icon}
                        </i>
                      )}
                      <span>{isActiveAction ? "Updating..." : action.label}</span>
                    </button>
                  );
                })}
              </div>
            </section>
          </div>
          ) : null}
          {supportsOutletMeasurements && (
            <div className="cell large-12">
              <OutletTrendPanel
                title="Outlet power trends"
                subtitle={outletSubtitle}
                serialNumber={serial}
                outlet={outlet}
              />
            </div>
          )}
          <div className="cell large-6">
            <RowList
              rows={[
                {
                  label: "Outlet Stats",
                  labelStyle: {
                    fontWeight: "bold",
                    fontSize: "110%",
                  },
                },
                {
                  label: "Outlet State",
                  value: outlet.state,
                  valueStyle: {
                    color: outlet.state === "ON" ? "green" : "red",
                    fontWeight: "600",
                  },
                },
                {
                  label: "Current RMS",
                  value:
                    outlet.currentRms !== undefined
                      ? `${outlet.currentRms.toFixed(2)} A`
                      : "-",
                },
                {
                  label: "Apparent Power",
                  value:
                    outlet.power !== undefined
                      ? `${outlet.power.toFixed(2)} VA`
                      : "-",
                },
                {
                  label: "Circuit Voltage",
                  value:
                    outlet.circuitVoltage !== undefined
                      ? `${outlet.circuitVoltage.toFixed(2)} V`
                      : "-",
                },
              ]}
            />
            <div style={{ margin: "20px" }}></div>
            <RowList
              rows={[
                {
                  label: "Outlet Information",
                  labelStyle: {
                    fontWeight: "bold",
                    fontSize: "110%",
                  },
                },
                {
                  label: "Outlet",
                  value: `Outlet ${outlet.pduLabeledOutletNum}`,
                },
                {
                  label: "Enclosure SN",
                  value: outlet.enclosureSerialNumber,
                },
                {
                  label: "Receptacle",
                  value: outlet.receptacle,
                },
                {
                  label: "Outlet ID",
                  value: outlet.outlet_id,
                },
                {
                  label: "Relay Health",
                  value:
                    outlet.relayHealth !== undefined
                      ? outlet.relayHealth
                      : "-",
                  valueStyle: {
                    color: outlet.relayHealth === "OK" ? "green" : "red",
                    fontWeight: "600",
                  },
                },
                {
                  label: "Connection State",
                  value: outlet.connectionState,
                  valueStyle: {
                    fontWeight: "500",
                  },
                },
              ]}
            />
          </div>
          <div className="cell large-6">
            <TextInput
              label="Outlet Name"
              value={this.state.outletName}
              disabled={!canEditOutlets || this.state.savingName}
              placeholder="Enter Outlet Name"
              callback={
                canEditOutlets
                  ? (txt) => {
                  this.setState({ outletName: txt, hasNameChanges: true, nameError: "" });
                    }
                  : undefined
              }
            />
            {this.state.nameError ? <p role="alert">{this.state.nameError}</p> : null}
            {canEditOutlets ? (
              <>
                {outlet.connectionState !== "Connected" ? (
                  <p>Names are saved in CMP and sync when the device reconnects.</p>
                ) : null}
                <button
                  type="button"
                  className="button"
                  onClick={this.onSaveName}
                  disabled={(!this.state.hasNameChanges && outlet.nameSyncStatus !== "failed") || this.state.savingName}
                >
                  {this.state.savingName ? "Saving name..." : "Save name"}
                </button>
              </>
            ) : <p>Your role does not allow outlet editing.</p>}
            <h5>Outlet settings</h5>
            {canEditOutlets && !canEditSettings ? (
              <p>Power-up and reboot settings are available when the device and outlet are online.</p>
            ) : null}
            <SelectInput
              label="Power Up Initial State"
              info="After the PDU powers up from a cold boot, the outlet relay will switch to the Power Up Initial State. 'Previous' is the last known state before the shutdown occurred."
              value={this.state.pwrOnState}
              disabled={!canEditSettings || this.state.saving}
              callback={
                canEditSettings
                  ? (txt) => {
                  this.setState({ pwrOnState: txt, hasChanges: true });
                    }
                  : undefined
              }
              options={[
                {
                  value: "ON",
                  label: "On",
                },
                {
                  value: "OFF",
                  label: "Off",
                },
                {
                  value: "PREV",
                  label: "Last Known State",
                },
              ]}
            />

            <ToggleInput
              label="Custom Reboot Time Enabled"
              description="Enable custom reboot time for this outlet when cycling power. Default global reboot time is 5 seconds, override with the following setting."
              value={this.state.customRebootTimeEnabled}
              type="checkbox"
              checked={this.state.customRebootTimeEnabled}
              disabled={!canEditSettings || this.state.saving}
              callback={
                canEditSettings
                  ? (status) => {
                  this.setState({
                    customRebootTimeEnabled: status,
                    hasChanges: true,
                  });
                    }
                  : undefined
              }
              id="custom-reboot-time-enabled"
            />

            <TextInput
              label="Custom Reboot Time"
              value={this.state.customRebootTime}
              description
              disabled={!canEditSettings || this.state.saving}
              callback={
                canEditSettings
                  ? (txt) => {
                  this.setState({
                    customRebootTime: txt,
                    hasChanges: true,
                  });
                    }
                  : undefined
              }
              type="number"
              placeholder="Enter Custom Reboot Time in seconds"
            />
            {this.state.settingsError ? <p role="alert">{this.state.settingsError}</p> : null}
            {canEditOutlets ? (
              <div>
                <button
                  type="button"
                  className="button secondary"
                  onClick={this.onCancel}
                  disabled={!this.state.hasChanges || this.state.saving}
                >
                  Cancel settings
                </button>{" "}
                <button
                  type="button"
                  className="button"
                  onClick={this.onSave}
                  disabled={!canEditSettings || !this.state.hasChanges || this.state.saving}
                >
                  {this.state.saving ? "Saving settings..." : "Save settings"}
                </button>
              </div>
            ) : null}
          </div>
          <br />
          <br />
        </div>
      </div>
    );
  }
}
